const nullNotifier = {
    open: () => { },
    close: () => { },
    destroy: () => { },
};
export const getNullApplicationNotifications = () => ({
    toast: nullNotifier,
    overlayBanner: nullNotifier,
    pageBanner: nullNotifier,
    debugger: nullNotifier,
});
//# sourceMappingURL=getNullApplicationNotifications.js.map